<template>
    <b-form-group :label="label" label-for="roles">
        <Select
            id="roles"
            :state="state"
            :selected="value"
            :options="options"
            aria-describedby="rolesTypeFeedback"
            :disabled="disabled"
            :loading="loading"
            @changeValue="$emit('update:value', $event)"
            @click="getRolesFromApi()"
        />
        <b-form-invalid-feedback id="rolesTypeFeedback">
            <slot />
        </b-form-invalid-feedback>
    </b-form-group>
</template>

<script>
import i18n from '@/i18n'
import { Select } from '@/views/components/selects'
import api from '@/services/api'

export default {
    name: 'Roles',
    components: {
        Select,
    },
    props: ['value', 'state', 'disabled', 'label'],
    data() {
        return {
            options: [],
            loading: false,
        }
    },
    mounted() {},
    methods: {
        getRolesFromApi() {
            if (!this.options.length) {
                this.loading = true
                api.get('/roles')
                    .then(resp => {
                        this.options = this.mapperToSelect(resp.data.data)
                    })
                    .catch(e => {
                        console.log(e)
                    })
                    .finally(() => {
                        this.loading = false
                    })
            }
        },
        mapperToSelect(roles) {
            return roles.map(role => {
                return {
                    value: role.id,
                    label: i18n.t(`roles.${role.name}`),
                }
            })
        },
    },
}
</script>
